import { format } from 'date-fns';
import { Chip, TableCell, TableRow } from '@mui/material';
import ScorecardUserCard from './ScorecardUserCard';

const TOTAL_COLUMNS = 10;

export default function WeekSection({
  periodKey,
  weekLabel,
  weekStart,
  weekEnd,
  users,
  surveyQuestions,
  onIssueClick,
}) {
  // Build the separator label
  let separatorLabel;
  if (!periodKey) {
    // not_filled tab
    separatorLabel = 'Not Submitted';
  } else {
    // e.g. "Week 18 · 28 Apr – 04 May 2026"
    const weekNum = periodKey.split('-')[1]; // "18"
    const dateRange =
      weekStart && weekEnd
        ? `${format(new Date(weekStart), 'dd MMM')} – ${format(new Date(weekEnd), 'dd MMM yyyy')}`
        : weekLabel;
    separatorLabel = `Week ${weekNum} · ${dateRange}`;
  }

  return (
    <>
      {/* Week separator row */}
      <TableRow>
        <TableCell
          colSpan={TOTAL_COLUMNS}
          sx={{
            py: 0.75,
            px: 1.5,
            bgcolor: 'grey.100',
            borderTop: '2px solid',
            borderBottom: '1px solid',
            borderColor: 'divider',
            position: 'sticky',
            top: 41,
            zIndex: 1,
          }}
        >
          <Chip
            label={separatorLabel}
            size="small"
            sx={{ fontWeight: 700, mr: 1, fontSize: '0.78rem' }}
          />
          <Chip
            label={`${users.length} developer${users.length !== 1 ? 's' : ''}`}
            size="small"
            variant="outlined"
            sx={{ fontSize: '0.75rem' }}
          />
        </TableCell>
      </TableRow>

      {/* User rows */}
      {users.map((user) => (
        <ScorecardUserCard
          key={user.userId}
          user={user}
          surveyQuestions={surveyQuestions}
          onIssueClick={onIssueClick}
        />
      ))}
    </>
  );
}
